import React from 'react';
import { ReviewCard } from '../../components/ReviewCard';
import { STORM_REVIEWS } from '../../components/realReviews';
export function FarmingtonReviews() {
  return <section className="py-24 bg-off-white" data-id="element-1310">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1311">
        <h2 className="text-4xl md:text-5xl text-ink text-center mb-16" data-id="element-1312">
          Trusted by Local Families
        </h2>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-1313">
          {STORM_REVIEWS.slice(3, 6).map(review => <ReviewCard key={review.name} quote={review.quote} name={review.name} label={review.label} data-id="element-1314" />)}
        </div>
      </div>
    </section>;
}